<desy-header [expandedLogo]="true">
  <desy-header-subnav>PREALTAS</desy-header-subnav>

  @if (AuthenticationService.User()) {
    <desy-header-dropdown data-cy="header-dropdown" classesTooltip="w-64 overflow-y-auto">
      <span class="block text-right">Hola, {{ AuthenticationService.UserCompleteName() | titlecase }}</span>
      <desy-content>
        <div>
          <dl>
            <dd class="px-base pt-sm text-neutral-dark text-sm">
              {{ AuthenticationService.User().organismName | titlecase }}
            </dd>
            <dd
              class="px-base py-sm hover:bg-primary-base focus:bg-warning-base focus:shadow-outline-focus flex cursor-pointer items-center text-sm hover:text-white focus:text-black focus:outline-none"
              (click)="authenticationService.logout()"
              data-cy="cerrar-session">
              Cerrar sesión
            </dd>
          </dl>
        </div>
      </desy-content>
    </desy-header-dropdown>
  }
</desy-header>
